import { StyledDocumentContainer } from 'fitify-ui-landing/src/components/blocks/Document/Document.Styled'
import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const StyledLegalDocumentContainer = styled(StyledDocumentContainer)`
  padding: 80px 20px 0;
  margin: 0 auto;

  ${phone(css`
    padding: 40px 20px 0;
  `)}

  * {
    padding: 0;
  }

  ul {
    ${phone(css`
      margin-block: 0;
      padding-inline-start: 24px;
    `)}
  }
`
